import ServicePageTemplate from '../ServicePageTemplate';
import { patioFaqs } from '../../../mocks/faqs';

export default function PaverPatios() {
  return (
    <ServicePageTemplate
      heroTitle="Custom Paver Patio Installation"
      heroSubtitle="Transform your backyard into a stunning outdoor living space with a custom paver patio designed for Florida living."
      heroImage="https://www.parksidepavers.com/files/projects/15/images/thumb/thumb_large_Albano%2Dlanai%2Ejpg"
      serviceBreakdownTitle="Our Patio Installation Services"
      serviceBreakdown={[
        { title: 'Custom Patio Design', desc: 'Unique layouts and patterns designed to complement your home and landscaping perfectly.', icon: 'ri-home-4-line' },
        { title: 'Stone & Concrete Pavers', desc: 'A wide selection of stone, concrete, and porcelain pavers in dozens of styles and colors.', icon: 'ri-stack-line' },
        { title: 'Outdoor Living Layouts', desc: 'Designed to accommodate furniture, fire features, and entertainment areas seamlessly.', icon: 'ri-fire-line' },
        { title: 'Seating Walls & Features', desc: 'Integrated seating walls, borders, and accents that define and elevate your patio space.', icon: 'ri-layout-column-line' },
      ]}
      aiAnswerText="Paver patio installation involves designing and constructing a durable outdoor space using interlocking pavers. These patios provide long-lasting performance, visual appeal, and low maintenance compared to traditional concrete. Parkside Pavers specializes in custom patio installations throughout Tampa, St. Petersburg, Clearwater, and surrounding areas, ensuring designs that match your lifestyle and stand up to Florida weather."
      aiAnswerBenefits={[
        'More durable than poured concrete',
        'Won\'t crack in Florida heat',
        'Easily repairable individual pavers',
        'Wide range of styles & colors',
        'Adds significant property value',
        'Low long-term maintenance',
      ]}
      faqs={patioFaqs}
      seoCity="Tampa Bay"
    />
  );
}
